import {IFeatureFlagConfig} from "@pg-mono/amplitude";

export enum KmFeatureFlag {
    // Keep in sync with the flag key configured in Amplitude.
    InvestmentListLayout = "km-investment-list-layout",
    Turnstile = "km-turnstile"
}

export const kmFeatureFlags: IFeatureFlagConfig[] = [
    {
        id: KmFeatureFlag.InvestmentListLayout,
        name: "KM Investment List Layout",
        variants: ["control", "treatment"]
    },
    {
        id: KmFeatureFlag.Turnstile,
        name: "KM Turnstile",
        variants: ["on"]
    }
];
import {IFeatureFlagConfig} from "@pg-mono/amplitude";

export enum KmFeatureFlag {
    // Keep in sync with the flag key configured in Amplitude.
    InvestmentListLayout = "km-investment-list-layout",
    Turnstile = "km-turnstile"
}

export const kmFeatureFlags: IFeatureFlagConfig[] = [
    {
        id: KmFeatureFlag.InvestmentListLayout,
        name: "KM Investment List Layout",
        variants: ["control", "treatment"]
    },
    {
        id: KmFeatureFlag.Turnstile,
        name: "KM Turnstile",
        variants: ["on"]
    }
];
